import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Firebase web config is safe to expose publicly — security is enforced by
// Firestore rules and Auth, not by hiding these values. Env vars take
// precedence so staging/alternate projects can override without code changes;
// the fallbacks keep production working even if env vars aren't configured.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC_HQLQzVN9_8eStd5A3VVT34bd62di6GU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "subtrack-f7a3f.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "subtrack-f7a3f",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "subtrack-f7a3f.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "38520019183",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:38520019183:web:ed2647e715e2cb7eca231a",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-7M8HLT3FQY",
};

const app = initializeApp(firebaseConfig);

// ── Firebase App Check ───────────────────────────────────────────────────────
// Must initialize before other Firebase services are obtained.
// Activates automatically once REACT_APP_RECAPTCHA_SITE_KEY is set (Vercel env
// var, build-time). Get a ReCaptcha v3 site key from:
// console.firebase.google.com → App Check → ReCaptcha v3, then enable
// enforcement for Firestore in the Firebase console.
if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);
